<div class="containerWrapper">
  <div class="currencyWrapper">
    <form [formGroup]="settingsForm" id="settingsForm" (ngSubmit)="saveSettings()">
      <h1 class="shippingTitle">{{ 'Product Options' | translate }}</h1>
      <div class="wrapper">
        <div class="estimatedTime">
          <div class="estimatedField">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Select-currency' | translate }}</mat-label>
              <mat-select [(ngModel)]="currency" (ngModelChange)="activateSave()" formControlName="currency">
                <mat-option *ngFor="let currency of CurrencyList" value="{{ currency.code }}"> {{ currency.symbol }} : {{ currency.name }} </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="estimatedField">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Select Country Option' | translate }}</mat-label>
              <mat-select formControlName="countryOptions">
                <mat-option [value]="'all'">{{ 'All Countries' | translate }}</mat-option>
                <mat-option [value]="'multi'">{{ 'Multi Countries' | translate }}</mat-option>
                <mat-option [value]="'single'">{{ 'Single Country' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="estimatedField">
            <mat-form-field appearance="outline" *ngIf="settingsForm.get('countryOptions')?.value === 'multi'">
              <mat-label>{{ 'Select Countries' | translate }}</mat-label>
              <mat-select formControlName="selectedCountries" multiple>
                <mat-option *ngFor="let country of countries" [value]="country.dial_code"> {{ country.emoji }} {{ country.name }} ({{ country.dial_code }}) </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="countryNumber estimatedField" *ngIf="settingsForm.get('countryOptions')?.value === 'single'">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Enter Country Code' | translate }}</mat-label>
              <input matInput formControlName="countryNumber" placeholder="20" (input)="startWithPlus($event)" />
            </mat-form-field>
          </div>
        </div>
        <div class="estimatedTime">
          <div class="countryNumber estimatedField">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Estimated Delivery Time' | translate }}</mat-label>
              <input matInput formControlName="estimatedDeliveryTime" placeholder="20" />
            </mat-form-field>
          </div>
          <div class="countryNumber estimatedField">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Time Unit' | translate }}</mat-label>
              <mat-select formControlName="estimatedDeliveryUnit">
                <mat-option value="minutes">{{ 'Minutes' | translate }}</mat-option>
                <mat-option value="hours">{{ 'Hours' | translate }}</mat-option>
                <mat-option value="days">{{ 'Days' | translate }}</mat-option>
                <mat-option value="weeks">{{ 'Weeks' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="enablePart">
        <h3>{{ 'Hide Out Stock Product' | translate }}</h3>
        <div>
          <mat-slide-toggle class="" formControlName="hideOutStockProduct"> </mat-slide-toggle>
        </div>
      </div>

      <div class="enablePart">
        <h3>{{ 'Use variant image as main image' | translate }}</h3>
        <div>
          <mat-slide-toggle class="" formControlName="useVariantImageAsMain"> </mat-slide-toggle>
        </div>
      </div>

      <div class="enablePart">
        <h3>{{ 'Allow Upload ' | translate }}</h3>
        <div>
          <mat-slide-toggle class="" formControlName="allowUpload"> </mat-slide-toggle>
        </div>
      </div>

      <h1 class="shippingTitle">{{ 'Shipping Options' | translate }}</h1>      
      <div class="wrapper">
        <div class="estimatedTime">
          <div class="estimatedField">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Choose Shipping Option' | translate }}</mat-label>
              <mat-select formControlName="shippingOption" (selectionChange)="activateSave()">
                <mat-option value="show">{{ 'Show' | translate }}</mat-option>
                <mat-option value="free">{{ 'Free Shipping' | translate }}</mat-option>
                <mat-option value="hide">{{ 'Hide' | translate }}</mat-option>
                <mat-option value="contact">
                  {{ 'A customer service will contact you regarding the shipping fees' | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- <div class="enablePart">
        <h3>{{ 'Enable Free Shipping' | translate }}</h3>
        <div>
          <mat-slide-toggle class="" formControlName="freeShipping"> </mat-slide-toggle>
        </div>
      </div> -->
      <div class="enablePart">
        <h3>{{ 'Enable Google Maps' | translate }}</h3>
        <div>
          <mat-slide-toggle class="" formControlName="enableGoogleMaps"> </mat-slide-toggle>
        </div>
      </div>
      <div class="enablePart">
        <h3>{{ 'Show Area' | translate }}</h3>
        <div>
          <mat-slide-toggle class="" formControlName="showArea"> </mat-slide-toggle>
        </div>
      </div>
      <div class="enablePart">
        <h3>{{ 'Show Country ' | translate }}</h3>
        <div>
          <mat-slide-toggle class="" formControlName="showCountry"> </mat-slide-toggle>
        </div>
      </div>
      <!-- Order Settings section -->
      <h1 class="shippingTitle">{{ 'Order Booking Options' | translate }}</h1>

      <div class="enablePart">
        <h3>{{ 'Enable Order Booking' | translate }}</h3>
        <div>
          <mat-slide-toggle formControlName="enableOrderBooking"></mat-slide-toggle>
        </div>
      </div>
      
      <!-- Show schedule component only if enabled -->
      <div *ngIf="settingsForm.get('enableOrderBooking')?.value">
        <app-schedule-settings (scheduleChange)="onScheduleChange($event)"></app-schedule-settings>
      </div>

      <h1 class="shippingTitle">{{ 'Contact Options' | translate }}</h1>

      <div class="enablePart">
        <h3>{{ 'Show Instagram' | translate }}</h3>
        <div>
          <mat-slide-toggle class="" formControlName="showInstagram"> </mat-slide-toggle>
        </div>
      </div>
      <div class="enablePart">
        <h3>{{ 'Show Facebook' | translate }}</h3>
        <div>
          <mat-slide-toggle class="" formControlName="showFacebook"> </mat-slide-toggle>
        </div>
      </div>

      <div class="enablePart">
        <h3>{{ 'show Phone Number' | translate }}</h3>
        <div>
          <mat-slide-toggle class="" formControlName="showPhoneNumber"> </mat-slide-toggle>
        </div>
      </div>
     
      <h1 class="shippingTitle">{{ 'Email on Order' | translate }}</h1>

      <div class="enablePart">
        <h3>{{ 'Email on Order' | translate }}</h3>
        <div>
          <mat-slide-toggle formControlName="enableOrderEmail"> </mat-slide-toggle>
        </div>
      </div>

      <div *ngIf="settingsForm.get('enableOrderEmail')?.value" class="emailContainer">
        <!-- Left: Email Template -->
        <div class="emailData textarea">
          <mat-form-field subscriptSizing="dynamic" appearance="outline">
            <mat-label>{{ 'Email Template' | translate }}</mat-label>
            <textarea matInput formControlName="emailTemplate" [placeholder]="'Write your email message here...' | translate"></textarea>
          </mat-form-field>
        </div>

        <!-- Right: Subject and Signature -->
        <div class="emailRightSide">
          <div class="emailData">
            <mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>{{ 'Email Subject' | translate }}</mat-label>
              <input matInput formControlName="emailSubject" [placeholder]="'Your Order Confirmation' | translate" />
            </mat-form-field>
          </div>
          <div class="emailData">
            <mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>{{ 'Signature' | translate }}</mat-label>
              <input matInput formControlName="emailSignature" [placeholder]="'Your Store Team' | translate" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="footWrapper">
        <div class="pixelWrapper">
          <h1 class="shippingTitle">{{ 'Pixel' | translate }}</h1>

          <div class="countryNumber metaWrapper">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Meta Pixel' | translate }}</mat-label>
              <input matInput formControlName="meta_pixel_id" placeholder="pixelId" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'Client Token' | translate }}</mat-label>
              <input matInput formControlName="meta_client_token" [placeholder]="'client Token' | translate" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'facebook Display Name' | translate }}</mat-label>
              <input matInput formControlName="facebook_displayName" [placeholder]="'facebook Name' | translate" />
            </mat-form-field>
          </div>
        </div>
      </div>
      <app-fin-cart></app-fin-cart>
    </form>
  </div>
</div>
